// src/components/ActingAsBanner.jsx
//
// High-contrast banner shown when an agency owner is operating an agent's
// workspace. Renders nothing when there's no active overlay.

import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function ActingAsBanner() {
  const { user, exitWorkspace } = useAuth();

  if (!user || !user.actingAs) return null;

  const agentName = user.actingAs.name || user.actingAs.email || 'agent';

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-amber-400 text-amber-950 border-b-2 border-amber-600 sticky top-0 z-40"
    >
      <div className="px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div className="text-sm font-semibold truncate">
            You are operating <span className="font-bold">{agentName}</span>'s workspace
            <span className="hidden sm:inline font-normal text-amber-900">
              {' '}— all actions appear as them.
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={exitWorkspace}
          className="flex-shrink-0 px-3 py-1 bg-amber-950 text-amber-50 rounded-md text-sm font-semibold hover:bg-black transition-colors"
        >
          Exit workspace
        </button>
      </div>
    </div>
  );
}
